import http from './base/http';

// 档口管理列表
export function archivesMouthList(data) {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 4,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 新增档口
export function addArchivesMouth(data) {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 1,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 修改档口
export function editArchivesMouth(data) {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 3,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 禁用档口
export function stopArchivesMouth(data) {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 2,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 启用档口
export function enableArchivesMouth(data) {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 18,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 获取人员
export function getUser(data) {
  const params = {
    SERVICE_ID: '10002',
    OTYPE: 4,
    USER_ID: parseInt(sessionStorage.getItem('userId')),
    SESSION: sessionStorage.getItem('session'),
    TC_ID: parseInt(sessionStorage.getItem('companyId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/api/archivesMouths.js